<template>
    <div class="user-violations-container" >
        <span class="empty" v-if="violations.length == 0">
            {{ toLocal('settings.no_penalties') }}
        </span>
        <span class="show-more-row" :class="{'active': show_mode == 'all'}" v-if="((Object.keys(violations).length < totalCount) || ((show_mode < Object.keys(violations).length)) && show_mode != 'all')" @click="toggleShowMore">
            <div class="icon">
                <svg  width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.82993 4.36948L0.986006 7.84696C0.877687 7.94495 0.730775 8 0.577589 8C0.424403 8 0.277491 7.94495 0.169172 7.84696C0.0608528 7.74896 1.14133e-09 7.61606 0 7.47747C-1.14133e-09 7.33889 0.0608528 7.20599 0.169172 7.10799L3.60516 4.00043L0.170133 0.892008C0.116499 0.843487 0.0739538 0.785884 0.0449272 0.722488C0.0159007 0.659092 0.000960821 0.591145 0.00096082 0.522526C0.000960819 0.453907 0.0159007 0.38596 0.0449272 0.322564C0.0739538 0.259168 0.116499 0.201565 0.170133 0.153044C0.223767 0.104523 0.28744 0.0660344 0.357516 0.039775C0.427593 0.0135156 0.5027 -5.11252e-10 0.57855 0C0.6544 5.11252e-10 0.729507 0.0135156 0.799584 0.039775C0.86966 0.0660344 0.933333 0.104523 0.986967 0.153044L4.83089 3.63052C4.88458 3.67904 4.92716 3.73666 4.95618 3.8001C4.9852 3.86353 5.00009 3.93153 5 4.00018C4.99991 4.06883 4.98484 4.13679 4.95566 4.20017C4.92647 4.26354 4.88375 4.32108 4.82993 4.36948Z" fill="#7D7E81"/>
                </svg>
            </div>
            <span>
                {{toLocal('generic.show_more')}}
            </span>
        </span>
        <div class="violation-wrapper">
            <div class="violation" v-for="(violation_date) in Object.keys(violations).slice(0, show_mode == 'all' ? Object.keys(violations).length : show_mode)" :key="violation_date">
                <span class="date">
                    <div class="icon circle">
                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="4" cy="4" r="3.5" fill="#6A6A6A"/>
                        </svg>
                    </div>
                    {{getFormattedDate(violation_date)}}
                </span>
                <span class="violation-text" v-for="violation in violations[violation_date]" :key="violation.id">
                    {{ violation.type }} 
                    {{ violation.count }}
                </span>
            </div>
        </div>
        <span class="show-more-row show-less" :class="{'active': show_mode == 'all'}" v-if="((Object.keys(violations).length < totalCount) || (show_mode < Object.keys(violations).length)) && show_mode == 'all'" @click="toggleShowMore">
            <div class="icon">
                <svg  width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.82993 4.36948L0.986006 7.84696C0.877687 7.94495 0.730775 8 0.577589 8C0.424403 8 0.277491 7.94495 0.169172 7.84696C0.0608528 7.74896 1.14133e-09 7.61606 0 7.47747C-1.14133e-09 7.33889 0.0608528 7.20599 0.169172 7.10799L3.60516 4.00043L0.170133 0.892008C0.116499 0.843487 0.0739538 0.785884 0.0449272 0.722488C0.0159007 0.659092 0.000960821 0.591145 0.00096082 0.522526C0.000960819 0.453907 0.0159007 0.38596 0.0449272 0.322564C0.0739538 0.259168 0.116499 0.201565 0.170133 0.153044C0.223767 0.104523 0.28744 0.0660344 0.357516 0.039775C0.427593 0.0135156 0.5027 -5.11252e-10 0.57855 0C0.6544 5.11252e-10 0.729507 0.0135156 0.799584 0.039775C0.86966 0.0660344 0.933333 0.104523 0.986967 0.153044L4.83089 3.63052C4.88458 3.67904 4.92716 3.73666 4.95618 3.8001C4.9852 3.86353 5.00009 3.93153 5 4.00018C4.99991 4.06883 4.98484 4.13679 4.95566 4.20017C4.92647 4.26354 4.88375 4.32108 4.82993 4.36948Z" fill="#7D7E81"/>
                </svg>
            </div>
            <span>
                {{toLocal('user_logs.show_less')}}
            </span>
        </span>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    props:{
        user: Object
    },
    data(){
        return{
            violations: [],
            show_mode: 3,
            totalCount: 0,
            loadedAll: false
        }
    },
    mounted(){
        this.loadViolations();
    },
    methods:{

        loadViolations(){
             axios.get( 
                `${this.$store.state.api_link}/user/${this.user.id}/violations?show=${this.show_mode}`,
                this.$store.getters.axiosConfig()
            ).then((res) => {
                if(this.show_mode == 'all'){
                    this.loadedAll = true;
                }
                this.violations = res.data.violations;
                if(res.data.total_count != null)
                    this.totalCount = res.data.total_count;
            })
        },
        getFormattedDate(date){
            let date_formatted = new Date(date);
            let year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date_formatted);
            let month = new Intl.DateTimeFormat('en', { month: 'numeric' }).format(date_formatted);
            let day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date_formatted);
            if(this.$store.state.language == 'en'){
                return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
            }
            else if(this.$store.state.language == 'lt'){
                return `${year} m. ${this.toLocal('new_player.month.'+(parseInt(month)-1))} ${day} d.`;
            }
            else{
                return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
            }
        },
        toggleShowMore(){
            if(this.show_mode == 'all'){
                this.show_mode = 3;
            }
            else{
                this.show_mode = 'all';
                if(!this.loadedAll){
                    this.loadViolations();
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.show-more-row{
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-weight: 600;
    cursor: pointer;
   
    svg{
        width: 6px;
        height: 10px;
        transition: transform 0.3s;
    }
    &.active{
        svg{
            transform: rotate(90deg);
        }
    }
    &.show-less{
        &.active{
            svg{
                transform: rotate(-90deg);
            }
        }
    }
}
.icon{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 0.8rem;
    height: 0.8rem;
    &.circle{
        width: 0.9rem;
        height: 0.9rem;
    }
}
.user-violations-container{
    display: flex;
    flex-direction: column;
    gap: 21px;
    padding: 1.4rem 1rem;
    margin-bottom: 1rem;
    background-color: #F4F4F4;
    border-radius: 0.6rem;
    font-size: 14px;
}
.violation-wrapper{
     display: flex;
    flex-direction: column;
    gap: 21px;
    background-color: #F4F4F4;
    border-radius: 0.6rem;
    max-height: 23rem;
    padding: 2px 0;
    overflow: auto;
    font-size: 14px;
}
.violation{
    display: flex;
    flex-direction: column;
    color: #7D7E81;
    font-size: clamp(13px, 1.2vw, 16px);
    line-height: 18px;
    font-weight: medium;
    gap: 5px;
}
.date{
    display: flex;
    align-items: center;
    gap: 0.4rem; 
    font-weight: bold;
}
.violation-text{
    padding-left: 1.3rem;
}
</style>